import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-missing-building',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="w-full h-full flex items-center justify-center p-6">
      <div class="max-w-xl w-full rounded-md bg-white shadow-custom-2 p-8 text-center flex flex-col gap-3">
        <h1 class="oswald-font text-3xl uppercase text-nside-orange-400">Missing Building ID</h1>
        <p class="text-slate-700">
          This form app must be opened with a building-scoped URL such as
          <span class="font-semibold">/building/:buildingId</span>.
        </p>
        <p class="text-sm text-slate-500">
          If this app is loaded in an iframe, update the parent URL so it passes the correct building ID.
        </p>
      </div>
    </div>
  `
})
export class MissingBuildingComponent {}
